<template>
  <div>
    <div class="position-relative">
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-dark shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex align-items-center">
          <div class="col px-0">
            <div class="row justify-content-center align-items-center">
              <div class="col-lg-7 text-center pt-lg">
                <p class="h1 text-white mt-4 mb-5">Sørensen–Dice coefficient</p>
                <p class="lead text-white mt-4 mb-0">Sørensen–Dice coefficient is a number between 0 - 1 which means the similarity in a percentage of the typed words. This index is known by several other names:
                    Sørensen–Dice index, Sørensen index and Dice's coefficient. </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <section class="section section-lg mt--300">
      <div class="" shadow>
        <div class="container" shadow>
          <div class="row justify-content-center" shadow>
            <div class="col-lg-4" shadow>
              <input
                type="text"
                class="form-control"
                v-model="firstWord"
                id="firstWord"
                placeholder="First word"
                aria-label="firstWord"
                shadow
              />
            </div>
            <div class="col-lg-4" shadow>
              <input
                type="text"
                class="form-control"
                v-model="secondWord"
                id="secondWord"
                placeholder="Second word"
                aria-label="secondWord"
                shadow
              />
            </div>
            <div class="buttono" shadow>
              <base-button
                class="btn-3"
                type="primary"
                icon="ni ni-bag-17"
                @click="matchWords"
                shadow
                >MATCH IT!</base-button
              >
            </div>
          </div>
          <div class="shadow my-5">
          </div>
          <h2 class="text-center my-5 py-5">
            <b>Your coefficient is: {{ diceResult }}</b>
          </h2>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Carousel from "./components/Carousel.vue";
const axios = require("axios");

export default {
  name: "home",
  components: { Carousel },
  data: function () {
    return {
      firstWord: null,
      secondWord: null,
      loading: false,
      diceResult: null,
    };
  },
  methods: {
    matchWords(){
      this.loading = true;
      let concatenation = this.firstWord+'-'+this.secondWord;
      axios.get('https://owum2l5qvk.execute-api.us-east-1.amazonaws.com/dev/matcher?words=', {
        params: {
          words: concatenation
        }
      }).then( (response) => {
        this.loading = false;
        this.diceResult = response.data.input.dice_coefficient;
      }).catch( (error) => {
        console.log(error);
      }) 
    }
  },
};
</script>
